import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { AppConfig } from '../../AppConfig';
import { AppTheme, AppStyles } from '../../styles/AppTheme';
import { CommonStyles } from '../../styles/Styles';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import { ButtonComponent } from '../../components/quizzing/ButtonComponent';
import { Helper } from '../../common/helpers/Helper';

export class StepperButtonComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
    }
  }

  render() {
    if (this.props.noQues) {
      return ''
    }

    const activeStep = this.props.activeStep
    const subSectionCompleted = this.props.subSectionCompleted

    return (
      <div className={css(Styles.buttonOuterContainer)}>
        {/* <Button className={css(Styles.buttonContainer,Styles.buttonContainerSecond)}>
        CLEAR
        </Button> */}
        {/* <div>
          {subSectionCompleted[activeStep] === true &&
            <p className={css(Styles.buttonInnerContent)}>You have already completed this section</p>
          }
        </div> */}

        {(!this.props.retake) &&
          subSectionCompleted &&
          <div>
            <p className={css(Styles.buttonInnerContent)}>You have already completed this section</p>
            <p className={css(Styles.subText)}>Your responses have been encrypted and archived for security and privacy reasons</p>
          </div>
        }

        {(!this.props.retake) &&
          this.props.subSectionReTake &&
          <p className={css(Styles.subText)}>{Helper.getString('reTakeSurvey')}</p>
        }


        <p className={css(CommonStyles.errMsg)}>{this.props.errMsg ? this.props.errMsg : ''}</p>

        <div className={css(Styles.buttonInnerContainer)}>

          {(!this.props.retake) &&
            this.props.subSectionReTake &&
            <ButtonComponent
              label='RETAKE'
              inProcess={this.props.inProcess}
              onSelect={this.props.onReTake}
            />
          }
          {((!subSectionCompleted && !this.props.introQues) || this.props.retake) &&
            <ButtonComponent
              label='SUBMIT'
              inProcess={this.props.inProcess}
              onSelect={this.props.onDone}
            />
          }
          <ButtonComponent
            label={((subSectionCompleted && !this.props.retake) || this.props.introQues) ? 'NEXT' : 'VISIT LATER'}
            inProcess={this.props.inProcess}
            onSelect={() => this.props.onSkip((subSectionCompleted && !this.props.retake) || this.props.introQues)}
            className={css(Styles.buttonContainerSecond)}
          />
        </div>
      </div>
    );
  }
}

const Styles = StyleSheet.create({
  buttonOuterContainer: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column'
  },
  buttonInnerContent: {
    fontSize: AppTheme.subTitleSize,
    margin: AppTheme.pMargin,
    marginBottom: 50,
    textAlign: 'center',
    fontWeight: 'bold',
    '@media (max-width: 767px)': {
      fontSize: AppTheme.subTitleSizeBelow767,
    }
  },
  buttonInnerContainer: {
    // flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  buttonContainerSecond: {
    minWidth: 200,
    fontSize: 22,
    fontWeight: 'normal',
    borderRadius: 30,
    margin: '0px 10px',
    display: 'flex',
    alignItems: 'center',
    '@media (max-width: 767px)': {
      minWidth: 100,
      fontSize: 15,
      borderRadius: 25,
    },
    backgroundColor: 'transparent',
    boxShadow: 'unset',
    color: AppTheme.tertiaryColor,
  },
  marginLeft: {
    marginLeft: 10,
  },
  subText: {
    fontSize: AppTheme.subTitleSize,
    '@media (max-width: 767px)': {
      fontSize: AppTheme.subTitleSizeBelow767,
    },
    textAlign: 'center'
  }
})


// WEBPACK FOOTER //
// ./src/components/quizzing/StepperButtonComponent.js